import SectionViewSwitch from '../../../SectionViewSwitch';
import Container from './GallectionViewSwitcher.container';

export default Container(SectionViewSwitch);
